// extracted by mini-css-extract-plugin
export var legendIndicator = "_ch-1";
export var legendRight = "_ch-0";